module.exports = __webpack_public_path__ + "img/stoneholder-1@2x.e54912d.png";